import { Subscription } from "contexts/SubscriptionContext";
import ISessionFormation from "models/ISessionFormation";

export class CoursesHelper {
    static filterCoursesByLanguage(courses: ISessionFormation[], languages: string[]): ISessionFormation[] {
        return courses.filter(course => languages.includes(course.langue));
    }

    static filterCoursesByCategory(selectedCourses: ISessionFormation[], catArr: string[]): ISessionFormation[] {
        // Handle the case where all categories are selected
        if ((catArr.length === 1 && catArr[0] === "AllCategories")) {
            return selectedCourses.slice();
        }

        // Use reduce to accumulate the filtered courses
        return selectedCourses.reduce((acc: ISessionFormation[], course: ISessionFormation) => {
            if (course && course.categories && course.categories.length > 0) {
                const matchesCategory = course.categories.some((courseCat) => catArr.includes(courseCat.id));
                if (matchesCategory && !acc.some((courseEx) => courseEx.id === course.id)) {
                    acc.push(course);
                }
            }
            return acc;
        }, []);
    }

    static filterCoursesBySubscription(selectedCourses: ISessionFormation[], subscription: Subscription | null): ISessionFormation[] {
        if (subscription === null) { return []; }

        let coursesBySubscription: ISessionFormation[] = [];
        if (selectedCourses) {
            selectedCourses.forEach((course: ISessionFormation) => {
                if (course) {
                    if (course.typesAbonnements && course.typesAbonnements.length > 0) {
                        course.typesAbonnements.forEach((s) => {
                            if (s && s.id === subscription?.abonnement?.id) {
                                coursesBySubscription.push(course);
                            }
                        });
                    }
                }
            });
        }

        return coursesBySubscription;
    }

    static filterCoursesByText(selectedCourses: ISessionFormation[],
        searchText: string,
        langOptions: string[]
    ): ISessionFormation[] {

        let coursesByText: ISessionFormation[] = [];
        if (selectedCourses) {
            selectedCourses.forEach((course: ISessionFormation) => {
                if (course) {
                    langOptions.forEach((lng) => {
                        if (lng && course.titreLong && course.titreLong[course.langue] && course.titreLong[course.langue].toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) {
                            if (!coursesByText.some((crs) => crs.id === course.id)) {
                                coursesByText.push(course);
                            }
                        }
                    });
                    if (course.formateur && course.formateur.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) {
                        if (!coursesByText.some((crs) => crs.id === course.id)) {
                            coursesByText.push(course);
                        }
                    }
                }
            });
        }

        return coursesByText;
    }

    static filterCoursesByFeatured(selectedCourses: ISessionFormation[]): ISessionFormation[] {
        return selectedCourses.filter((course: ISessionFormation) => course.enVedette === true);
    }

    static filterCoursesByMostPopular(selectedCourses: ISessionFormation[]): ISessionFormation[] {
        return selectedCourses.filter((course: ISessionFormation) => course.populaire === true);
    }

    static sortSessions(a: ISessionFormation, b: ISessionFormation): number {
        const dateComparison = new Date(a.dateSession).getTime() - new Date(b.dateSession).getTime();
        if (dateComparison !== 0) {
            return dateComparison;
        } else {
            return a.id.localeCompare(b.id);
        }
    }

    static copyAndSort<T>(items: T[], columnKey1: string, columnKey2?: string, isSortedDescending?: boolean): T[] {
        const key1 = columnKey1 as keyof T;
        if (columnKey2) {
            return items.slice(0).sort((a: T, b: T) =>
                (isSortedDescending ? (a[key1] as any)[columnKey2] < (b[key1] as any)[columnKey2] : (a[key1] as any)[columnKey2] > (b[key1] as any)[columnKey2]) ? 1 : -1
            );
        } else {
            return items.slice(0).sort((a: T, b: T) =>
                (isSortedDescending ? a[key1] < b[key1] : a[key1] > b[key1]) ? 1 : -1
            );
        }
    }

    static displayHour(course: ISessionFormation): string | null {
        if (!course?.dateSession) {
            return null;
        }

        const dateSession = new Date(course.dateSession);
        // Format hours and minutes from the dateSession
        const hours = dateSession.getHours().toString().padStart(2, '0');
        const minutes = dateSession.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    }

    static getMonthArray(lang = "fr") {
        const theDate = new Date();
        theDate.setDate(1);
        let theYear = theDate.getFullYear();
        let theMonth = theDate.getMonth() + 1;
        let monthName = theDate.toLocaleString(lang, { month: 'long' });
        monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
        const monthArray = [];
        for (let i = 1; i < 13; i++) {
            monthArray.push({
                year: theYear.toString(),
                month: (theMonth < 10) ? "0" + theMonth : theMonth.toString(),
                monthName: monthName
            });
            theDate.setMonth(theDate.getMonth() + 1);
            monthName = theDate.toLocaleString(lang, { month: 'long' });
            monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
            theMonth = theDate.getMonth() + 1;
            theYear = theDate.getFullYear();
        }
        return monthArray;
    }
}